import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./AccuracyScore.module.scss";

export interface IAccuracyScoreProps {
  score: number;
}

export const AccuracyScore: VoidFunctionComponent<IAccuracyScoreProps> = ({score}) => {
  const scoreClasses: string[] = [];
  if (score >= 80) {
    scoreClasses.push(s.passingScore);
  } else {
    scoreClasses.push(s.notPassingScore);
  }

  return (
    <div className={s.accuracyScore}>
      <dt>Accuracy score</dt>
      <dd className={scoreClasses.join(` `)}>{score}%</dd>
    </div>
  );
}
